module.exports = __webpack_public_path__ + "static/media/everton.bb14389e.png";